// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1O3dk","savePackageButton":"ClientWallet_savePackageButton__sAUa2"};